import React,{useState} from "react";
import { Box,Button } from "@mui/material";
import { setupManagementUrl } from "../../../config";
import RightsForm from "./forms";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import BankBranchesForm from "./forms";
import Joyride from "react-joyride"; // Import Joyride


const base_url = setupManagementUrl.uri;

// Define tour steps for the Disbursement Methods page
const BankBranchesTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Bank branches setup page, where you can manage Bank branches.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific Bank branches by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Bank branch.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  {
    target: ".dynamic-table-actions",
    content: "Select actions like Edit for each Bank branch from this dropdown.",
    placement: "left",
  },
];
const BankBranchesTable = () => {
    const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride
  
  const actions = {
    entity: localStorage.getItem("SelectedTabLabel"),
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    dataObject: {
      ignoreFields: ["UpdateDate", "CreateDate","PostalAddress", "PostalCode","Company", "CharLimit"],
      objectName: "allBankBranchesView",
      parameters: "",
    },
    required: "rightIds",
    isSubRight: true,
    showStatus:true,
    showMore:{
      search:false,
      min: 0,
      max:0
    }
  };

  return (
    <Box m="20px">
      {/* Joyride Component */}
           <Joyride
                    steps={BankBranchesTourSteps}
                    run={runTour}
                    continuous
                    showSkipButton
                    showProgress
                    styles={{
                      options: {
                        primaryColor: "#1976d2",
                        zIndex: 10000,
                      },
                    }}
                  />
                    {/* Top Bar */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
                Start Page Tour
              </Button>
            </Box>

      <DynamicTableForJson
        title="Bank Branches"
        subtitle="Manage Bank Branches"
        FormComponent={BankBranchesForm}
        base_url={base_url}
        actions={actions}
        tourSteps={BankBranchesTourSteps} // Pass tour steps as prop
      />
    </Box>
  );
};

export default BankBranchesTable;
